<template>
  <div id="app">
    <RwvHeader :categories = "categories"/>
    <div class="home-page">
      <RwvSliderHome v-if="isHome()"></RwvSliderHome>
      
      <section class="main pt-1 pb-3">
        <div class="container">
            <div class="row">
                <div class="col-lg-9">  
                    <RwvMenuPrd/>
                    <router-view></router-view>
                </div>
                <div class="col-lg-3">
                    <div class="aside-item sidebar_support pb-4">                        				
                        <div class="blockTitle">				
                            <h2>Hỗ trợ trực tuyến</h2>
                        </div>
                        <div class="module-content">
                            <div class="item">
                                <div class="item_image">
                                    <img src="/img/item_1_image.png" class="img-responsive" alt="tu-van-ban-hang-1">
                                </div>
                                <div class="item_desc">
                                    <div class="item_title">
                                        Hotline + Zalo
                                    </div>
                                    <div class="item_sum">                                       
                                        <a class="item_check" href="tel:0918894567" title="0918894567">
                                            09 1889 4567
                                        </a>
                                    </div>
                                </div>
                            </div>		
                            <!-- <div class="item">
                                <div class="item_image">
                                    <img src="/img/item_1_image.png" class="img-responsive" alt="tu-van-ban-hang-2">
                                </div>
                                <div class="item_desc">
                                    <div class="item_title">
                                        Tư vấn bán hàng 2
                                    </div>
                                    <div class="item_sum">
                                        <label class="item_detail">
                                            P2:
                                        </label>
                                        <a class="item_check" href="tel:0869073070" title="0869 073 070">
                                            &nbsp;0869 073 070
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <div class="item_image">
                                    <img src="/img/item_1_image.png" class="img-responsive" alt="tu-van-ban-hang-2">
                                </div>
                                <div class="item_desc">
                                    <div class="item_title">
                                        Tư vấn bán hàng 2
                                    </div>
                                    <div class="item_sum">
                                        <label class="item_detail">
                                            P3:
                                        </label>
                                        <a class="item_check" href="tel:0909228569" title="0909 228 569">
                                            &nbsp;0909 228 569
                                        </a>
                                    </div>
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="item_image">
                                    <img src="/img/item_3_image.png" class="img-responsive" alt="email-lien-he">
                                </div>
                                <div class="item_desc">
                                    <div class="item_title">
                                        Email liên hệ
                                    </div>
                                    <div class="item_sum">                                        
                                        <a class="item_check " href="kinhdoanhocvit@gmail.com" title="kinhdoanhocvit@gmail.com" style="    font-size: 16px;    color: #a5a4a4;">
                                            &nbsp;kinhdoanhocvit@gmail.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="aside-item sidebar_doi-tac pb-4">                        				
                        <div class="blockTitle">				
                            <h2>Đối tác</h2>
                        </div>
                        <div class="module-content">
                            <RwvPartner />
                        </div>                    
                    </div> 
                    <div class="aside-item sidebar_thong-ke">                        				
                        <div class="blockTitle">				
                            <h2>Thống kê</h2>
                        </div>
                        <div class="module-content">
                            <RwvThongKe/>              
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
      <div class="bottom-contact">
        <ul>
            <li>
                <a id="goidien" href="tel:0918894567">
                <img src="/img/phone.svg">
                <br>
                <span>Gọi điện</span>
                </a>
            </li>
            <li>
                <a id="chatzalo" href="https://zalo.me/0918894567" target="_blank">
                <img src="/img/zalo.svg">
                <br>
                <span>Chát zalo</span>
                </a>
            </li>
            <li>
                <a id="chatfb" href="m.me/bao-gia-phu" target="_blank">
                <img src="/img/mesenger.svg">
                <br>
                <span>Chát FB</span>
                </a>
            </li>
            <!-- <li>
                <a id="nhantin" href="#"> 
                <img src="/img/chat.svg"> 
                <br>
                <span>Nhắn tin</span>    
                </a>    
            </li> -->
        </ul>
      </div>
      
      

      <RwvFooter />
      <RwvBackToTop 
          :visibleoffset="visibleoffset" 
          :bottom="bottom" 
          :right="right"/>
      </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RwvHeader from "@/components/TheHeaderWeb";
import RwvFooter from "@/components/TheFooterWeb";
import RwvSliderHome from "@/components/sections/SliderHome";
import RwvCategory from "@/components/Category";
import RwvBackToTop from "@/components/BacktoTop";
import RwvMenuPrd from "@/components/MenuPrd";
import RwvPartner from "@/components/sections/Partner";
import RwvThongKe from "@/components/ThongKe";
import { FETCH_CATEGORIES, FETCH_NEW_PRODUCTS, FETCH_LATEST_NEWS } from "@/store/actions.type";

export default {
  name: "App",
  components: {
    RwvHeader,
    RwvFooter,    
    RwvSliderHome,
    RwvCategory,
    RwvBackToTop,
    RwvMenuPrd,
    RwvPartner,
    RwvThongKe
   
  },
  data () {
    return {
      isBackTopFooter: false,
      visibleoffset: 600,
      text: 'Back to top',
      bottom: '40px',
      right: '40px'
    }
  },
  mounted() {   
    this.$store.dispatch(FETCH_CATEGORIES);
    this.$store.dispatch(FETCH_NEW_PRODUCTS);
    this.$store.dispatch(FETCH_LATEST_NEWS);
  },
  computed: {
    ...mapGetters(["categories"])
  },
  methods: {
    isHome() {
      return this.$route.name == "home";
    }
  }
};
</script>

<style></style>
